import { useAsync } from "@react-hookz/web";
import React from "react";
import { StoreAutoCompleteOption } from "./StoreAutoCompleteOption";
import { IStore, getAllStores } from "@/api/store";
import { FormAutoCompleteElement } from "@rhf-kit/mui";

export const StoreAutoComplete = () => {
    const [stores, setStores] = React.useState<IStore[]>([]);

    const [searchValue, setSearchValue] = React.useState<string>("");
    const [debounce, setDebounce] = React.useState(searchValue);

    const [getStoresState, getStoresActions] = useAsync(getAllStores);

    // Set a debounce so we don't make loads of API calls.
    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebounce(searchValue);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchValue]);

    // retrieve stores for autocomplete field
    React.useEffect(() => {
        // check if the search has been set (passed the threshold of no typing)
        if (debounce.trim().length > 1) {
            getStoresActions.execute(undefined, undefined, {
                q: debounce,
                sort_by: "name",
            });
            // If we have nothing, just set to the first 10 or so stores.
        } else {
            getStoresActions.execute(undefined, 10, undefined);
        }
    }, [debounce, getStoresActions]);
    // set stores
    React.useEffect(() => {
        if (getStoresState.status === "success" && getStoresState.result) {
            setStores(getStoresState.result.items);
        }
    }, [getStoresState.status, getStoresState.result]);
    return (
        <FormAutoCompleteElement
            name={"stores"}
            label={"Store(s) (Optional)"}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => (option as IStore).name}
            noOptionsText={"No stores"}
            size="small"
            //track the search value
            onInputChange={(_, value) => setSearchValue(value)}
            autoComplete
            autoHighlight
            multiple
            includeInputInList
            options={stores}
            textFieldProps={{ margin: "normal" }}
            loading={getStoresState.status === "loading"}
            renderOption={(props, option) => (
                <StoreAutoCompleteOption
                    key={option.id}
                    option={option}
                    props={props}
                />
            )}
        />
    );
};
